import React, { Component } from 'react';
import { InfoWindow, TrafficLayer, withGoogleMap, GoogleMap, Marker } from 'react-google-maps';
import _ from 'underscore';
const Map = withGoogleMap((props) => {
    return (React.createElement(GoogleMap, { defaultZoom: 10, center: props.center },
        React.createElement(TrafficLayer, { autoUpdate: true }),
        props.markers));
});
const getMarkers = (arriving, delivering) => {
    const locations = [arriving, delivering];
    return locations.map((loc, idx) => {
        if (loc && loc.length) {
            return {
                seq: idx + 1,
                address: loc[0],
            };
        }
        return null;
    })
        .filter(loc => loc)
        .map((loc) => {
        return (React.createElement(Marker, { key: loc.address._id, icon: { url: `/img/stop-${loc.seq}.png` }, position: loc.address },
            React.createElement(InfoWindow, null,
                React.createElement("div", null, loc.address.address))));
    });
};
const getCenter = (arriving, delivering) => {
    if (arriving && arriving.length) {
        return _.pick(arriving[0], 'lat', 'lng');
    }
    if (delivering && delivering.length) {
        return _.pick(delivering[0], 'lat', 'lng');
    }
    return { lat: 34.025327, lng: -118.375244 };
};
export default class OrderMap extends Component {
    shouldComponentUpdate(nextProps) {
        if (!(_.isEqual(this.props.arriving, nextProps.arriving)) || !(_.isEqual(this.props.delivering, nextProps.delivering))) {
            return true;
        }
        return false;
    }
    render() {
        return (React.createElement(Map, { googleMapURL: "https://maps.googleapis.com/maps/api/js?client=gme-cargomaticinc&v=3.exp&libraries=geometry,drawing,places", loadingElement: React.createElement("div", { style: { height: '100%' } }), containerElement: React.createElement("div", { className: "h-80 sm:h-96 lg:h-112" }), mapElement: React.createElement("div", { style: { height: '100%' } }), markers: getMarkers(this.props.arriving, this.props.delivering), center: getCenter(this.props.arriving, this.props.delivering) }));
    }
}
